import { render, staticRenderFns } from "./ingreso.vue?vue&type=template&id=6e585e2e&scoped=true&"
import script from "./ingreso.vue?vue&type=script&lang=js&"
export * from "./ingreso.vue?vue&type=script&lang=js&"
import style0 from "./ingreso.vue?vue&type=style&index=0&id=6e585e2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e585e2e",
  null
  
)

export default component.exports